module.exports = __webpack_public_path__ + "media/images/event/image_03-8f600810044b70819bb8aeda091602bf.png";